export default __webpack_public_path__ + "static/media/vanguardev.97c8e017.png";